module.exports = __webpack_public_path__ + "img/home.9ffd8568.svg";